import { render, staticRenderFns } from "./RecordCheck.vue?vue&type=template&id=22db13d2&scoped=true&"
import script from "./RecordCheck.vue?vue&type=script&lang=js&"
export * from "./RecordCheck.vue?vue&type=script&lang=js&"
import style0 from "./RecordCheck.vue?vue&type=style&index=0&id=22db13d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db13d2",
  null
  
)

component.options.__file = "RecordCheck.vue"
export default component.exports